import * as React from 'react'
// views
import {
  ColumnActionButton,
  ColumnActions,
  ColumnContent,
  ColumnWrapper,
  IconWrapper,
  DragIcon,
  EditIcon,
  TrashIcon
} from 'components/Modals/PlanColumnsSettingsModal/views'
// types
import { IPlanColumn } from 'types/plan/columns'
// utils
import { getPlanColumnLabel } from 'constants/planColumns'

interface IIncomingProps {
  column: IPlanColumn
  isDisabled: boolean
  editColumn: () => void
  removeColumn: () => void
}

const Column: React.FC<IIncomingProps> = ({ isDisabled, column, editColumn, removeColumn }) => {
  return (
    <ColumnWrapper isDisabled={isDisabled}>
      <ColumnContent>
        <IconWrapper>
          <DragIcon />
        </IconWrapper>
        <span>{getPlanColumnLabel(column.fieldId)}</span>
      </ColumnContent>
      <ColumnActions>
        <ColumnActionButton onClick={editColumn}>
          <EditIcon />
        </ColumnActionButton>
        <ColumnActionButton onClick={removeColumn}>
          <TrashIcon />
        </ColumnActionButton>
      </ColumnActions>
    </ColumnWrapper>
  )
}

export default Column
